import Dialog from 'global/guides/Dialog'
import { AprovarService as useService } from '../../service/aprovar'

const AprovarAjusteModal: React.FC = () => {
    const { handleSubmit, isLoading } = useService()

    return (
        <Dialog.Root
            width="xs"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <Dialog.Content>
                Tem certeza que deseja aprovar o ajuste?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>Sim</Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default AprovarAjusteModal
